module.exports = __webpack_public_path__ + "img/allyshipQuote2@2x.ae686f89.jpg";